import { render, staticRenderFns } from "./MainEventWrapper.vue?vue&type=template&id=d895abaa"
import script from "./MainEventWrapper.vue?vue&type=script&lang=js"
export * from "./MainEventWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d895abaa')) {
      api.createRecord('d895abaa', component.options)
    } else {
      api.reload('d895abaa', component.options)
    }
    module.hot.accept("./MainEventWrapper.vue?vue&type=template&id=d895abaa", function () {
      api.rerender('d895abaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operations/MainEventWrapper.vue"
export default component.exports